import { useTagStyles } from '@chakra-ui/react-v2';
import { forwardRef } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { TagAction, type TagActionProps } from './TagAction';

export const TagRightAction = forwardRef<TagActionProps, 'button'>(
  ({ className, ...restProps }, ref) => {
    const styles = useTagStyles();

    return (
      <TagAction
        className={cx('tag__right-action', className)}
        sx={styles.rightAction}
        {...restProps}
        ref={ref}
      />
    );
  },
);
